module.exports = __webpack_public_path__ + "static/media/Biggs Darklighter.1d303942.jpg";